export const awsS3ErrorMessages = {
  initiateS3ConnectionError: 'initiateS3ConnectionError',
  createMultipartUploadError: 'createMultipartUploadError',
  completeMultipartUploadError: 'completeMultipartUploadError',
  abortMultipartUploadError: 'abortMultipartUploadError',

  uploadParamsNotFoundError: 'uploadParamsNotFoundError',
  uploadPartError: 'uploadPartError',
};
